module.exports = __webpack_public_path__ + "static/media/feature-4.bed8ca46.png";